module.exports = __webpack_public_path__ + "static/media/event-default.9e75f8ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/event-default.png
// module id = 887
// module chunks = 228